export const LATITUDE = -34.603613;
export const LONGITUDE = -58.381135;
export const ZOOM_DEFAULT = 16;
export const MARKER_ICON_SIZE = 57;
export const MARKER_ICON_CENTER = 28.5;
export const TRAVEL_MODE = "DRIVING";

export const NO_BOUNCING = 8;

export const DEFAULT_CENTER = {
  lat: LATITUDE,
  lng: LONGITUDE,
};

export const startLocation = {
  position: {
    lat: LATITUDE,
    lng: LONGITUDE,
  },
  key: Date.now(),
  defaultAnimation: NO_BOUNCING,
};
